<template>
  <div class="form-group">
    <ncs-label :id="`filters.${id}`"/>
    <multiselect v-model="selected"
                 :options="options"
                 track-by="value"
                 :custom-label="({ label }) => label"
                 group-values="values"
                 group-label="type"
                 :group-select="true"
                 :placeholder="$tOr(`filters.${id}.options`, null)"
                 :searchable="true"
                 :multiple="true"
                 :allowEmpty="true"
                 :close-on-select="false"
                 :show-labels="false"
                 :disabled="false">
      <template v-slot:noResult>
        <span v-html="$tOr(`filters.${id}.no_result`, $t('filters.no_result'))"></span>
      </template>
    </multiselect>
  </div>
</template>
<script>
import map from 'lodash/map'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: { Multiselect },
  props: {
    id: { type: String, required: true },
    elementFilterId: { type: String, required: true },
    elementType: { type: String, required: true },
    excludeInfos: { type: Array, default: () => [] },
    // Inherited from NcsFilter
    value: { type: String, default: null },
    operator: { type: String, default: 'array_overlaps' },
    disabled: { type: Boolean, default: false },
    dependencies: { type: Array, default: () => [] },
  },
  created() {
    if (!this.$store.state.filters.byId[this.elementFilterId]) {
      this.$store.commit('filters/addFilter', {
        id: this.elementFilterId,
        field: this.field,
        dependencies: this.dependencies,
        operator: this.operator,
        default: this.value,
        disabled: this.disabled
      })
    }
  },
  data() {
    return {
      field: `${this.elementType}.searchable_info`,
      options: [
        {
          type: 'Saludo / Presentación',
          values: [
            { label: 'Saludo / Presentación inicio', value: 'Saludo / Presentación' },
            { label: 'Saludo / Presentación respuesta', value: 'Saludo / Presentación respuesta' },
          ]
        },
        {
          type: 'Acto directivo',
          values: [
            { label: 'Acto directivo inicio', value: 'Acto directivo' },
            { label: 'Acto directivo respuesta', value: 'Acto directivo respuesta' },
          ]
        },
        {
          type: 'Ofrecimiento',
          values: [
            { label: 'Ofrecimiento inicio', value: 'Ofrecimiento' },
            { label: 'Ofrecimiento respuesta', value: 'Ofrecimiento respuesta' },
          ]
        },
        {
          type: 'Otras',
          values: ['Cita', 'Énfasis', 'Risa', 'Sigla']
              .filter(v => !this.excludeInfos.includes(v))
              .map(v => ({ label: v, value: v }))
        },
        {
          type: 'Pregunta',
          values: [
            { label: 'Interrogativa total', value: 'Pregunta interrogativa total' },
            { label: 'Interrogativa parcial', value: 'Pregunta interrogativa parcial' },
            { label: 'Interrogativa disyuntiva', value: 'Pregunta interrogativa disyuntiva' },
            { label: 'Interrogativa de eco', value: 'Pregunta interrogativa de eco' },
            { label: 'Interrogativa inconclusa', value: 'Pregunta interrogativa inconclusa' },
            { label: 'Enunciativa con confirmación', value: 'Pregunta enunciativa con confirmación' },
          ]
        },
        {
          type: 'Respuesta',
          values: [
            { label: 'Respuesta interrogativa total', value: 'Respuesta interrogativa total' },
            { label: 'Respuesta interrogativa parcial', value: 'Respuesta interrogativa parcial' },
            { label: 'Respuesta interrogativa disyuntiva', value: 'Respuesta interrogativa disyuntiva' },
            { label: 'Respuesta interrogativa de eco', value: 'Respuesta interrogativa de eco' },
            { label: 'Respuesta interrogativa inconclusa', value: 'Respuesta interrogativa inconclusa' },
            { label: 'Respuesta enunciativa con confirmación', value: 'Respuesta enunciativa con confirmación' },
          ]
        }
      ]
    }
  },
  computed: {
    selected: {
      get() {
        const values = this.$store.getters['filters/selectedValue'](this.elementFilterId)
        return filter(this.options.flatMap(g => g.values), o => includes(values, o.value))
      },
      set(v) {
        this.$store.commit('filters/setFilter', { [this.elementFilterId]: map(v, 'value') })
      }
    },
  }
}
</script>
<style lang="scss">
// Change vue-multiselect size to match default select
.multiselect {
  .multiselect__select {
    height: 32px; // Center right arrow
  }

  .multiselect__placeholder { // Avoid height change when selecting an option
    padding-top: 0;
    margin-bottom: 0;
  }
}
</style>
